import { TreeTable } from "primereact/treetable";
import styled from "styled-components";
import { colors } from "../../../../../../../../../theme/theme";

export const TreeTablePublishableStyled = styled(TreeTable)`
	.p-treetable-thead {
		display: none !important;
	}

	.p-treetable-toggler {
		position: absolute;
		z-index: 1;
		left: 16px;
		top: 6px;
	}

	.p-treetable-tbody > tr > td {
		position: relative;
		border: 0;
		padding: 0;
	}
`;

export const TableItem = styled.div`
	--side-padding: 16px;
	--toggler-spacing: 40px;
	position: relative;
	border-left: 4px solid ${colors.mainColors.blueberry};
	background: ${colors.mainColors.white_lilac};
	display: flex;
	align-items: center;
	gap: 16px;
	padding: 8px var(--side-padding) 8px
		calc(var(--side-padding) + var(--toggler-spacing));
	margin: 2px 0;
	overflow: hidden;

	&.Item {
		border-color: ${colors.mainColors.verde_dstore};
	}
	&.Item:not(.independent) {
		padding-left: calc(var(--side-padding) * 2 + var(--toggler-spacing));
	}

	&.Media {
		border-color: ${colors.mainColors.capri};
	}

	&.Media:not(.independent) {
		padding-left: calc(var(--side-padding) * 3 + var(--toggler-spacing));
	}
`;
